module.exports = __webpack_public_path__ + "static/media/logo.4ac3cc16.png";